/**
 * useCart
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import DineInCartContext from './dine-in-cart-context'

const useDineInCart = () => {
  const context = useContext(DineInCartContext)
  return context
}

export default useDineInCart
